import { render, staticRenderFns } from "./Internation.vue?vue&type=template&id=600297f3&scoped=true&"
import script from "./Internation.vue?vue&type=script&lang=js&"
export * from "./Internation.vue?vue&type=script&lang=js&"
import style0 from "./Internation.vue?vue&type=style&index=0&id=600297f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600297f3",
  null
  
)

export default component.exports